import { axios, securityAxios } from '@/utils/axios'
import { getThirdPartLoginHeader } from '@/lib/business'

// 获取用户真实账户开户信息
export function getUserOpenAccountInfo(userId) {
  return axios.get('/user/realAccountOpenInfo?userId=' + userId)
}

export function customerFollowup({ pageSize, pageNum, userId, startTime, endTime, remind }) {
  return axios.get(
    `/user/customerFollowup/list?pageNum=${pageNum}&pageSize=${pageSize}&userId=${userId}&beginTime=${startTime}&endTime=${endTime}&remind=${remind}`
  )
}

export function customerFollowupAdd(data) {
  return axios.post('/user/customerFollowup/add', data)
}

export function customerFollowupEdit(data) {
  return axios.post('/user/customerFollowup/edit', data)
}

export function customerFollowupDelete(id) {
  return axios.delete('/user/customerFollowup/remove?id=' + id)
}

export function hasdealpwd() {
  return axios.get('/user/hasdealpwd', {
    headers: {
      silent: true
    }
  })
}

export function getUserWallets() {
  return axios({
    url: '/user/wallets',
    method: 'get',
    headers: getThirdPartLoginHeader()
  })
}

export function getMtRealAccounts() {
  return securityAxios.post(
    '/user/mtaccount',
    { type: 'r' },
    {
      headers: getThirdPartLoginHeader()
    }
  )
}

export function getMtDemoAccounts() {
  return securityAxios.post(
    '/user/mtaccount',
    { type: 'd' },
    {
      headers: getThirdPartLoginHeader()
    }
  )
}

export function getMtAllAccounts() {
  return securityAxios.post(
    '/user/mtaccount',
    { type: 'a' },
    {
      headers: getThirdPartLoginHeader()
    }
  )
}

// 获取用户安全设置
export function getUserSecuritySettings() {
  return axios.get('/user/getSecuritySetting')
}

export function phishingCode(data) {
  return securityAxios.post('/user/phishingCode', data)
}

export function loginTwoFactorAuth(data) {
  return securityAxios.post('/user/loginTwoFactorAuth', data)
}

export function userLogin(data) {
  return securityAxios.post('/user/login/v1', data, {
    headers: {
      silent: true,
      'X-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
      'X-Resolution': window.screen.width + 'x' + window.screen.height
    }
  })
}

export function getTaLoginSetting() {
  return axios.get('/system/taLogin/getSetting')
}
// 修改资金密码
export function setFunPassword(data) {
  return securityAxios.post('/user/dealpwd', data)
}

export function loginTwoAuth(data) {
  return securityAxios.post('/user/loginTwoAuth', data)
}

// 用户登录记录
export function loginInfos({ pageNum, pageSize }) {
  return axios.get(`/user/loginInfos?pageNum=${pageNum}&pageSize=${pageSize}`)
}

export function getUserInfo() {
  return axios.get('/user/info', {
    headers: getThirdPartLoginHeader()
  })
}

export function getWebmsglist(data) {
  return securityAxios.post('/system/msg/webmsglist', data, {
    headers: sessionStorage.getItem('assetQuery.sign')
      ? {
          server: sessionStorage.getItem('assetQuery.server'),
          login: sessionStorage.getItem('assetQuery.login'),
          sign: sessionStorage.getItem('assetQuery.sign')
        }
      : {}
  })
}

export function webMsgReadAll(ids) {
  return axios.post('/system/msg/readall', {
    ids: ids
  })
}

export function getPopupMsg() {
  return axios.post(
    '/system/msg/popUpMsg',
    {},
    {
      headers: sessionStorage.getItem('assetQuery.sign')
        ? {
            server: sessionStorage.getItem('assetQuery.server'),
            login: sessionStorage.getItem('assetQuery.login'),
            sign: sessionStorage.getItem('assetQuery.sign')
          }
        : {}
    }
  )
}

export function setUserConfig(data) {
  return securityAxios.post('/user/editbase', data)
}

export function hasPosition(serverId, account) {
  return axios.get(`/common/hasPosition?serverId=${serverId}&login=${account}`)
}

export function getContact() {
  return axios.get(`/system/company/contact`)
}

// 菜单列表
export function getUserMenuList() {
  return axios.get(`/user/menuList`)
}

// 获取kyc用户信息
export function getUserColumn(type) {
  return axios.get(`/user/column/ini/${type}`)
}

// 提交代理注册申请
export function applyAgent(params) {
  return axios.post('/user/applyAgent', params, {
    headers: {
      'Content-Type': 'application/json' // 明确指定 JSON 格式
    }
  })
}

// 获取sumsub列表
export function getSumsubList(params) {
  return axios.post('/system/sumsub/list', params || {}, {
    headers: {
      'Content-Type': 'application/json' // 明确指定 JSON 格式
    }
  })
}

// 获取sumsub的accessToken
export function getSumsubAccessToken(levelName) {
  return axios.get(`/user/column/getAccessToken?levelName=${levelName}`)
}

// 未登录状态下获取accessToken
export function getSumsubAccessTokenWithoutLogin(levelName, email, phone) {
  return axios.get(`/user/column/getAccessTokenNoLogin?levelName=${levelName}&email=${email}&phone=${phone}`)
}

// 获取用户kyc信息 1-入金，2-出金，3-开户
export function getUserKyc(type) {
  return axios.get(`/user/kyc?type=${type}`)
}

// 获取引导信息
export function getShowGuide() {
  return axios.get(`/user/showGuide`)
}

// 添加用户查看手机号log
export function addCheckPhoneLog(inviteId) {
  return axios.get(`/user/userinfoPhone?id=${inviteId}`)
}

// 获取用户kyc信息新版 1-入金，2-出金，3-开户， 不传参时获取所有kyc信息
export function getUserKycStatus(type) {
  return axios.get(`/user/getkycStatus${type !== undefined ? '?type=' + type : ''}`)
}

export function getIsShowCreateAccount() {
  return axios.get('/user/showCreateWindows')
}
